// extracted by mini-css-extract-plugin
export default {"desa":"Navbar_desa__NKd1u","admin":"Navbar_admin__22Kcq","profile":"Navbar_profile__zVCLI"};